module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "id": "pii"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('a', {
    attrs: {
      "id": "piii"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "piv"
    }
  }), _vm._v(" The Harvard Common Press"), _c('br'), _vm._v("\n535 Albany Street • Boston, Massachusetts 02118"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.harvardcommonpress.com",
      "target": "_blank"
    }
  }, [_vm._v("www.harvardcommonpress.com")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Copyright © 2003 by Bill Hufnagle")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("A Few Words About Words")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Many of the folks who contributed recipes and I have used words and names that are"), _c('br'), _vm._v("\nthe trademarks of the Harley-Davidson Motor Company and/or the Buell Company."), _c('br'), _vm._v("\nAll possible efforts have been made to use these words in a descriptive manner. The"), _c('br'), _vm._v("\nHarvard Common Press and I respect the trademarks of the Harley-Davidson Motor"), _c('br'), _vm._v("\nCompany and the Buell Company and are grateful for the permission to use them"), _c('br'), _vm._v("\nwithin this book. Those trademarks are:")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Aluminator, Bad Boy, Badlander, Bazooka, Biker Blues, Buddy Seat, Diamond Back,"), _c('br'), _vm._v("\nDisc Glide, Dyna Glide, Eagle Iron, Electra Glide Road King, Enthusiast, Evolution,"), _c('br'), _vm._v("\nFantail, Fat Boy, FXR, FXRG, HD, H-D, H.O.G., Hog, Harley, Harley Chrome,"), _c('br'), _vm._v("\nHarley Owners Group, Harley Women, Harley-Davidson, Heritage Softail, Heritage"), _c('br'), _vm._v("\nSpringer, Howitzer, Hugger, Ladies of Harley, Low Rider, Motorclothes, Revolution,"), _c('br'), _vm._v("\nRoad Glide, Road King, Roadster, Screamin' Eagle, Softail, Sport Glide, Sportster,"), _c('br'), _vm._v("\nSpringer, Sturgis, Super Glide, The Legend Rolls On, Thunderstar, Tour Glide, Tour-"), _c('br'), _vm._v("\nPak, Ultra Classic, V-Rod, Wide Glide, Willie G., and the Harley-Davidson bar and"), _c('br'), _vm._v("\nshield logo are trademarks of H-D Michigan, Inc. Blast, Buell, Cyclone, Dynamic"), _c('br'), _vm._v("\nDigital, Firebolt, Fuel Injection, Lightning, and Thunderbolt are trademarks of Buell.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced or transmitted in"), _c('br'), _vm._v("\nany form or by any means, electronic or mechanical, including photocopying, record-"), _c('br'), _vm._v("\ning, or any information storage or retrieval system, without permission in writing"), _c('br'), _vm._v("\nfrom the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Printed in the United States of America"), _c('br'), _vm._v("\nPrinted on acid-free paper")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Hufnagle, Bill.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Biker Billy's hog wild on a Harley cookbook : 200 fiercely flavorful recipes to"), _c('br'), _vm._v("\nkick-start your home cooking from Harley riders across the USA / Bill Hufnagle."), _c('br'), _vm._v("\np. cm."), _c('br'), _vm._v("\nISBN 1-55832-250-7 ((hc) : alk. paper)"), _c('br'), _vm._v("\n1. Cookery. I. Title."), _c('br'), _vm._v("\nTX714.H82 2003"), _c('br'), _vm._v("\n641.5—dc21 2002154184")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("ISBN 13: 978-1-55832-250-9"), _c('br'), _vm._v("\nISBN 10: 1-55832-250-7")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Special bulk-order discounts are available on this and other Harvard Common Press"), _c('br'), _vm._v("\nbooks. Companies and organizations may purchase books for premiums or resale, or"), _c('br'), _vm._v("\nmay arrange a custom edition, by contacting the Marketing Director at the address"), _c('br'), _vm._v("\nabove.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("10 9 8 7 6 5 4")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("For interior photo credits see "), _c('span', {
    attrs: {
      "href": "#/back03#p312",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[>]")]), _vm._v(".")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("Cover design by Night & Day Design")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("Book design by Richard Oriolo")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-133015e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 60
// module chunks = 0